<template>
  <div class="container">
    <el-form :model="form" inline ref="refForm" :rules="rules">
      <el-form-item class="small_label" :label="$t('common.productName') + ':'" prop="productName">
        <el-select
          v-model="form.product"
          clearable
          filterable
          style="width: 200px;"
          size="small">
          <el-option
            v-for="item in productsList"
            :key="item.id"
            :label="item.productName + ' / ' + item.chipName"
            :value="item.productName + ' / ' + item.chipName">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="reset">{{$t('common.reset')}}</el-button>
        <el-button type="primary" size="small" @click="queryOrderRecord">
          {{$t('common.query')}}
        </el-button>
      </el-form-item>
    </el-form>
    <div class="separator"></div>
   <div class="control-container">
        <div>
          <span style="color:#404040;font-size:16px;">最近7天平均每天测试量:</span><span style="color:red;margin-left: 5px;font-size:20px;">{{formatterNumber(testCountForThePastWeek/7)}}</span>
          <span style="color:#404040;font-size:16px;margin-left: 20px;">可发货数:</span><span style="color:red;margin-left: 5px;font-size:20px;">{{send}}</span>
          <span style="color:#404040;font-size:16px;margin-left: 20px;">待测试数:</span><span style="color:red;margin-left: 5px;font-size:20px;">{{wait}}</span>
        </div>
    </div>
    <div class="control-container">
    <div>
      <span style="color:#404040;font-size:16px;">最近7天测试产品进度列表:</span><span style="color:red;margin-left: 5px;font-size:20px;"></span>
    </div>
    </div>

    <div class="target-container">
      <el-table
        ref="table"
        border
        :data="displayWeekData"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        header-cell-class-name="headerCellName">
        <el-table-column prop="prodInfo" :label="$t('common.productName')">
        </el-table-column>
        <el-table-column prop="count" :label="$t('common.count')">
          <template slot-scope="scope">
            {{(scope.row.count/1000).toFixed(1) + ' K'}}
          </template>
        </el-table-column>
        <el-table-column prop="incoCount" :label="$t('incomingOrder.incoCount')">
          <template slot-scope="scope">
            {{(scope.row.incoCount/1000).toFixed(1) + ' K'}}
          </template>
        </el-table-column>
        <el-table-column prop="finishCount" :label="$t('incomingOrder.finishCount')">
          <template slot-scope="scope">
            {{(scope.row.finishCount/1000).toFixed(1) + ' K'}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('incomingOrder.sendCount')">
          <template slot-scope="scope">
            {{((scope.row.sendFailCount + scope.row.sendPassCount)/1000).toFixed(1) + ' K'}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.sendNum')">
          <template slot-scope="scope">
            {{((scope.row.passCount + scope.row.failCount - scope.row.sendPassCount - scope.row.sendFailCount)/1000).toFixed(1) + ' K'}}
           </template>
         </el-table-column>
         <el-table-column :label="$t('common.waitNum')">
           <template slot-scope="scope">
             {{getwaitNum(scope.row)}}
             </template>
         </el-table-column>
      </el-table>
    </div>
    <div class="control-container">
    <div>
      <span style="color:#404040;font-size:16px;">全部产品进度列表:</span><span style="color:red;margin-left: 5px;font-size:20px;"></span>
    </div>
    </div>
    <div class="target-allcontainer">
      <el-table
        ref="table"
        height="100%"
        border
        :data="displayData"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        header-cell-class-name="headerCellName">
        <el-table-column prop="prodInfo" :label="$t('common.productName')"/>
        <el-table-column prop="count" :label="$t('common.count')">
            <template slot-scope="scope">
              {{(scope.row.count/1000).toFixed(1) + ' K'}}
            </template>
          </el-table-column>
          <el-table-column prop="incoCount" :label="$t('incomingOrder.incoCount')">
            <template slot-scope="scope">
              {{(scope.row.incoCount/1000).toFixed(1) + ' K'}}
            </template>
          </el-table-column>
          <el-table-column prop="finishCount" :label="$t('incomingOrder.finishCount')">
            <template slot-scope="scope">
              {{(scope.row.finishCount/1000).toFixed(1) + ' K'}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('incomingOrder.sendCount')">
            <template slot-scope="scope">
              {{((scope.row.sendFailCount + scope.row.sendPassCount)/1000).toFixed(1) + ' K'}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.sendNum')">
            <template slot-scope="scope">
              {{((scope.row.passCount + scope.row.failCount - scope.row.sendPassCount - scope.row.sendFailCount)/1000).toFixed(1) + ' K'}}
             </template>
           </el-table-column>
           <el-table-column :label="$t('common.waitNum')">
             <template slot-scope="scope">
               {{getwaitNum(scope.row)}}
               </template>
           </el-table-column>
        </el-table>
    </div>

  </div>
</template>

<script>
import { testCountReportGet } from '@/api/testCount';
import { productsList } from '@/api/products';

const defaultForm = {
  product: undefined,
};

export default {
  name: 'TestProgressList',
  data() {
    return {
      form: Object.assign({}, defaultForm),
      rules: {
      },
      page: 1,
      perpage: 20,
      listData: [],
      weekListData: [],
      testCountForThePastWeek: 0,
      wait: 0,
      send: 0,
      productsList: [],
    };
  },
  computed: {
    displayData() {
      return this.listData;
    },
    displayWeekData() {
      return this.weekListData;
    },
  },
  mounted() {
    this.incoOrderList();
    this.productsListGet(1, 200);
  },
  methods: {
    onChangePage() {
      this.incoOrderList();
    },
    async incoOrderList() {
      try {
        const {
          product,
        } = this.form;
        const res = await testCountReportGet({
          chipName: product ? product.split(' / ')[1] : undefined,
          prodNo: product ? product.split(' / ')[0] : undefined,
        });
        this.listData = res.data.dataGroupByProduct;
        this.weekListData = res.data.dataGroupByProduct_testForPastWeek;
        this.testCountForThePastWeek = res.data.testCountForThePastWeek;
        this.wait = 0;
        this.send = 0;

        for (let i = 0; i < this.weekListData.length; i++) {
          const item = this.weekListData[i];
          let temp1 = item.incoCount - item.passCount - item.failCount;
          let temp2 = item.incoCount - item.testCount;
          let str1 = temp1 < temp2 ? temp1 : temp2;
          let str2 = str1 > 0 ? str1 : 0;
          this.wait = this.wait + str2;
          this.send = this.send + item.passCount + item.failCount - item.sendPassCount - item.sendFailCount;
        }
        this.wait = (this.wait/1000).toFixed(1) + ' K';
        this.send = (this.send/1000).toFixed(1) + ' K';
      } catch (e) {
        // do nothing.
      }
    },
    async productsListGet(page, perpage) {
      try {
        const res = await productsList({ page, perpage });
        const { data } = res;
        this.productsList = data.records;
      } catch (e) {}
    },
    reset() {
      this.page = 1;
      this.form = Object.assign({}, defaultForm);
      this.incoOrderList();
    },
    queryOrderRecord() {
      this.page = 1;
      this.incoOrderList();
    },
    productName(row) {
      const { product } = row;
      if (!product) {
        return '';
      }
      return `${product.productName} / ${product.chipName}`;
    },
    formatterNumber(val) {
      if(val !== 0) {
        return (parseFloat(val)/1000).toFixed(1) + ' K';
      }
      return '0 K';
    },
    getwaitNum(row){
      let temp1 = row.incoCount - row.passCount - row.failCount;
      let temp2 = row.incoCount - row.testCount;
      let str = temp1 < temp2 ? temp1 : temp2;
      let w = (parseFloat(str)/1000).toFixed(1) + ' K'
      return str > 0 ? w : '0 K';
    },
  },
};
</script>

<style lang="scss" scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }
  .el-form {
    padding: 10px 20px 0;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: #E5E5E5;
    display: block;
  }
  .control-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    margin: 10px 20px;
  }
  .target-container {
    margin: 0 20px;
    margin-bottom: 5px;
  }
  .target-allcontainer {
    flex: 1;
    display: -webkit-flex;
    display: flex;
    margin: 0 10px;
    margin-bottom: 20px;
  }
  .bottom-container {
    text-align: center;
    position: relative;
    margin: 20px auto;
    width: 100%;
  }
  .link {
    color: #169BD5;
    padding: 0 5px;
  }
  .link.is-disabled {
    color: #C0C4CC;
  }
</style>
<style>
  .headerCellName {
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
  }
  .small_label .el-form-item__label {
    font-size: 12px;
  }
</style>
